import { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
	
import styles from "./IndEvent.module.css"
import PieModule from './PieModule';


const GuestiiTopbar = ({ event, eventOG, setEvent, setEventOG, setInvitingGuestii }) => {
	const [guestiiSearchText, setGuestiiSearchText] = useState("")


	useEffect(() => {
		const handleFilters = () => {
			let filteredGuestiis = [];

			if (guestiiSearchText && guestiiSearchText.length > 0) {
				const indEventGuestiis = [...eventOG.guestiis]
				const searchTrimmed = guestiiSearchText.trim().toLowerCase();

				const matchedIds = new Set();
				indEventGuestiis.forEach(g => {
				  	const fullName = `${g.guestii.first_name} ${g.guestii.last_name}`.toLowerCase();
				  	const phone = (g.guestii.phone || '').toLowerCase();
				  	const isMatch = fullName.includes(searchTrimmed) || phone.includes(searchTrimmed);

				  	if (!isMatch) return;

				  	if (g.source_model === 'Guestii') {
				    	const mainGuestiiId = g.source._id.toString();
				    	matchedIds.add(g.guestii._id.toString());
				    	matchedIds.add(mainGuestiiId);

				    	indEventGuestiis.forEach(other =>
				      		other.source._id.toString() === mainGuestiiId &&
				      		matchedIds.add(other.guestii._id.toString())
				    	);
				  	} else {
				    	matchedIds.add(g.guestii._id.toString());

					    indEventGuestiis.forEach(other =>
				      		other.source._id.toString() === g.guestii._id.toString() &&
				      		matchedIds.add(other.guestii._id.toString())
				    	);	
				  	}
				});

				filteredGuestiis = indEventGuestiis.filter(g =>
				  	matchedIds.has(g.guestii._id.toString())
				);
			} else {
				filteredGuestiis = [...eventOG.guestiis]
			}

			setEvent({ ...eventOG, ['guestiis']: filteredGuestiis })
		}

		handleFilters()
	}, [guestiiSearchText])

	return (
		<div className={styles.guestii_topbar}>
			<div className={styles.guestii_topbar_search}>
				<i className={`fa-solid fa-magnifying-glass ${styles.m1}`}></i>
				{guestiiSearchText === "" && <p className={`${styles.s1}`}>Search for any Guestii...</p>}

				<input
					type="text"
					className={styles.s1}
					onChange={(input) => setGuestiiSearchText(input.target.value)}
					value={guestiiSearchText}
				/>
			</div>

			<button className={styles.guestii_topbar_add} onClick={() => setInvitingGuestii(true)}>
				<i className={`fa-solid fa-plus ${styles.s3}`}></i>
				<p className={`${styles.s1}`}>Invite</p>
			</button>
		</div>
	)
}

const GuestiiTableDisplay = ({ event, mainLoading, selectedGuestiis, setSelectedGuestiis, settingTags, setSettingTags, toggledMenu, setToggledMenu, setSettingRating, setSettingTypes, setMainReloadKey, setSettingPlusOnes, settingPlusOnes, settingTypes, settingRating, setSettingPromoters, settingPromoters }) => {
	const param = useParams();
	const navigate = useNavigate();

	const [isLoading, setIsLoading] = useState(true);
	const [guestiis, setGuestiis] = useState([])
	const [guestiisOG, setGuestiisOG] = useState([])
	const [menuPos, setMenuPos] = useState({ top: 0, left: 0 });
	const containerRef = useRef(null);


  	useEffect(() => {
    	return () => {
    		setToggledMenu(null);
    	};
  	}, []);

	useEffect(() => {
		const handleNodes = async () => {
			setIsLoading(true)

			setGuestiis(event.guestiis)
			setGuestiisOG(event.guestiis)

			setIsLoading(false)
		}

		handleNodes()
	}, [event]);

	function processGuestiis(guestiis) {
		if (selectedGuestiis.length > 0) {
			return guestiis
		}

	  	const guestiiIds = new Set();

	  	guestiis.forEach(g => {
	    	if (g.source_model === 'Guestii') {
	      		guestiiIds.add(g.source._id.toString());
	    	}
	  	});

	  	const guestiisFiltered = guestiis.filter(g => {
      		const isFromGuestii = g.source_model === 'Guestii';
      		const isTargetGuestii = guestiiIds.has(g.guestii._id.toString());
      		return !isFromGuestii || isTargetGuestii;
    	}).map(g => ({
      		...g,
      		stacked_card: guestiiIds.has(g.guestii._id.toString())
    	}));

    	return guestiisFiltered;
	}

	const handleSelectGuestii = (g) => {
		if (selectedGuestiis.map(guestii => guestii.guestii._id.toString()).includes(g.guestii._id.toString())) {
			setSelectedGuestiis((prev) => [...prev].filter(p => p.guestii._id !== g.guestii._id.toString()))
			setGuestiis(guestiisOG)
		} else {
			setSelectedGuestiis((prev) => [...prev, g])
			const guestiiWithInvites = guestiisOG.filter(guestii => (guestii.guestii._id.toString() === g.guestii._id.toString()) || (guestii.source._id.toString() === g.guestii._id.toString()))
			if (guestiiWithInvites.length > 1) {
				setGuestiis(guestiiWithInvites)
			}
		}
	}

	const navigateToGuestii = () => {
		const userId = localStorage.getItem("_id")
		const state = { from: toggledMenu.guestii };
		sessionStorage.setItem('navigationState', JSON.stringify(state));

		navigate(`/guestiis/${userId}`)
	}

	const handleDelete = async () => {
		const confirmDelete = await window.confirm("Are you sure you want to remove this Guestii from this event?")
		if (!confirmDelete) { return; }
		setIsLoading(true)

		const userId = localStorage.getItem("_id")
		const expiry = localStorage.getItem("expiry")
		if (!userId || !expiry) {
			localStorage.removeItem("_id")
			localStorage.removeItem("expiry")
			window.location = "/connect"
		}

	  	try {
		    const res = await axios.delete(`/api/events/delete-guestii/${param.event_id}/${toggledMenu.guestii._id}`, {
		      	headers: {
		        	'x-user-id': userId,
		        	'x-expiry': expiry
		      	}
		    });

		    setMainReloadKey((prevKey) => prevKey + 1);
		    setToggledMenu(null)
	  	} catch (err) {
			localStorage.removeItem("_id")
			localStorage.removeItem("expiry")
			window.location = "/connect"
	  	}

  		setIsLoading(false)
	}

	return (
		<>
			{(!isLoading && !mainLoading)
				?
					<div
						style={{
							height: '100%',
							maxHeight: '100%',
							overflowY: 'scroll',
							position : 'relative'
						}}
						ref={containerRef}
						onClick={e => {
							if (toggledMenu) {
							    setToggledMenu(null);
							    setMenuPos({ top: 0, left: 0 });
							}
						}}
					>
						{guestiis.length > 0
							?
								<div
									className={`${styles.table_container_indguestii} ${toggledMenu && styles.toggled_hidden_container} table_container`}
									style={{ gridTemplateRows: `max-content`, marginTop: '1rem' }}
								>
									{processGuestiis(guestiis).map((g, i) => {
										const stacked_card = g.stacked_card || false
										const name = `${g.guestii.first_name} ${g.guestii.last_name} ${((!g.guestii.first_name || g.guestii.first_name === "") && (!g.guestii.last_name || g.guestii.last_name === "")) ? "-" : ""}`
										
										const totalRows = Math.ceil(guestiis.length / 3);
										const currentRow = Math.floor(i / 3) + 1;
										const inLastRow = currentRow === totalRows;

										const isSelected = selectedGuestiis.map(guestii => guestii.guestii._id.toString()).includes(g.guestii._id.toString())

										return (
											<button
												className={`${styles.guestii_invited_container} ${inLastRow && styles.paddingLastItem}`}
												onClick={() => handleSelectGuestii(g)}
												// disabled={(!selectedGuestii || (selectedGuestii && selectedGuestii.guestii._id.toString() !== g.guestii._id.toString())) ? !stacked_card : false}
											>
												<div
													className={`${styles.guestii_invited_ind_max} ${g.admitted && styles.guestii_admitted_in} ${isSelected && styles.guestii_invited_active}`}
													style={{ zIndex: 3, top: 0 }}
												>
													<div className={styles.guestii_inner_split}>
														<div className={`${styles.guestii_profile_rounded} ${isSelected && styles.guestii_profile_active}`}><i className={`fa-solid fa-${isSelected ? "check" : "user"} ${styles.s1}`}></i></div>
														<div className={styles.guestii_profile_info}>
															<div className={styles.name_container}>
																<p className={styles.s1}>{name}</p>
																<p className={`${styles.xs2}`}>{g.guestii.phone || "-"}</p>
															</div>
														</div>

														<div className={styles.top_right_modules}>
									                      	<button
									                      		className={styles.ellipsis_container}
																onClick={e => {
																	e.stopPropagation();

																	if (toggledMenu && toggledMenu.guestii._id === g.guestii._id) {
																	    setToggledMenu(null);
																	    setMenuPos({ top: 0, left: 0 });
																	} else {
																		const btnRect = e.currentTarget.getBoundingClientRect();
																		const contRect = containerRef.current.getBoundingClientRect();

																		setMenuPos({
																			top: btnRect.top - contRect.top + containerRef.current.scrollTop + 20,
																			left: btnRect.left - contRect.left - 155,
																		});

																	    setToggledMenu(g);
																	}
																}}
									                      	>
									                        	<i className={`fa-solid fa-ellipsis ${styles.m2}`}></i>
									                      	</button>
								                      	</div>
													</div>
												</div>

												{stacked_card &&
													<div
														className={`${styles.guestii_invited_ind_max} ${styles.guestii_invited_inner}`}
														style={{ transform: `scale(0.${100 - (1 * 5)})`, zIndex: 2, bottom: `-10px` }}
													>
													</div>
												}
											</button>
										)
									})}
								</div>
							: <div className={styles.invite_first}><p className={styles.m1}>Invite your first guestii!</p></div>
						}

                      	{(toggledMenu && settingPlusOnes.length === 0 && settingTypes.length === 0 && settingTags.length === 0 && !settingRating) &&
                      		<div
                      			className={styles.toggled_menu}
							    style={{
							      position: 'absolute',
							      top: `${menuPos.top}px`,
							      left: `${menuPos.left}px`
							    }}
	                      		onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
	                      		}}
                      		>
                      			<div className={styles.toggled_header}>
                      				<i className={`fa-solid fa-gear ${styles.m1}`}></i>
                      				<p className={styles.s2}>Guestii Tools</p>
                      			</div>

		                      	<button
		                      		className={`${styles.tmenu_container}`}
		                      		onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
		                      			setSettingPlusOnes([toggledMenu]);
		                      		}}		                      		
		                      	>
		                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
		                        	<p className={styles.s1}>Set Plus Ones</p>
		                      	</button>

		                      	<button
		                      		className={`${styles.tmenu_container}`}
		                      		onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
		                      			setSettingTypes([toggledMenu]);
		                      		}}		                      		
		                      	>
		                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
		                        	<p className={styles.s1}>Set Type</p>
		                      	</button>

		                      	<button
		                      		className={`${styles.tmenu_container}`}
		                      		onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
		                      			setSettingTags([toggledMenu]);
		                      		}}		                      		
		                      	>
		                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
		                        	<p className={styles.s1}>Set Tags</p>
		                      	</button>

		                      	<button
		                      		className={`${styles.tmenu_container}`}
		                      		onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
		                      			setSettingPromoters([toggledMenu]);
		                      		}}		                      		
		                      	>
		                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
		                        	<p className={styles.s1}>Set Promoter</p>
		                      	</button>

		                      	<button
		                      		className={`${styles.tmenu_container}`}
		                      		onClick={(e) => {
										e.preventDefault();
										e.stopPropagation();
		                      			setSettingRating(true);
		                      		}}
		                      	>
		                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
		                        	<p className={styles.s1}>Set Rating</p>
		                      	</button>

		                      	<button
		                      		className={`${styles.tmenu_container}`}
		                      		onClick={() => navigateToGuestii()}
		                      	>
		                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
		                        	<p className={styles.s1}>Open in Guestiis</p>
		                      	</button>

		                      	{!toggledMenu.admitted &&
			                      	<button
			                      		className={`${styles.tmenu_container}`}
			                      		onClick={(e) => {
											e.preventDefault();
											e.stopPropagation();
			                      			handleDelete()
			                      		}}
			                      	>
			                        	<i className={`fa-solid fa-arrow-right ${styles.s3}`}></i>
			                        	<p className={styles.s1}>Delete Guestii</p>
			                      	</button>
		                      	}
                      		</div>
                      	}
					</div>
				:
					<div
						style={{
							height: '100%',
							maxHeight: '100%',
							overflowY: 'scroll',
							position : 'relative'
						}}
					>
						<div className={`${styles.table_container_indguestii} table_container`} style={{ gridTemplateRows: `max-content`, marginTop: '1rem' }}>
							{Array.from({ length: 45 }).map((node, n) => {
								const totalRows = Math.ceil(45 / 3);
								const currentRow = Math.floor(n / 3) + 1;
								const inLastRow = currentRow === totalRows;

								return (
									<div className={`${styles.guestii_invited_ind_max} ${inLastRow && styles.paddingLastItem} ${styles.no_hover} shine-animation`}>
										<div className={styles.guestii_inner_split}>
											<div className={styles.guestii_profile_rounded}><i className={`fa-solid fa-user ${styles.s1}`}></i></div>

											<div className={styles.guestii_profile_info_loading}>
												<p className={styles.s1} style={{ visibility: 'hidden' }}>Example Guestii</p>
												<p className={styles.xs2} style={{ visibility: 'hidden' }}>example@guestii.app</p>
											</div>
							            </div>
					                </div>
					            )
					        })}
						</div>
					</div>
			}
		</>
	)
}

const GuestiiModule = ({ event, eventOG, setEvent, setEventOG, mainLoading, selectedGuestiis, setSelectedGuestiis, setInvitingGuestii, settingTags, setSettingTags, toggledMenu, setToggledMenu, setSettingRating, setSettingTypes, setMainReloadKey, setSettingPlusOnes, settingPlusOnes, settingTypes, settingRating, setSettingPromoters, settingPromoters }) => {
	return (
		<>
			<GuestiiTopbar
				event={event}
				eventOG={eventOG}
				setEvent={setEvent}
				setEventOG={setEventOG}
				setInvitingGuestii={setInvitingGuestii}
			/>

    		<GuestiiTableDisplay
    			event={event}
    			mainLoading={mainLoading}
    			selectedGuestiis={selectedGuestiis}
    			setSelectedGuestiis={setSelectedGuestiis}
    			settingTags={settingTags}
    			setSettingTags={setSettingTags}
    			toggledMenu={toggledMenu}
    			setToggledMenu={setToggledMenu}
    			setSettingRating={setSettingRating}
    			setSettingTypes={setSettingTypes}
    			setMainReloadKey={setMainReloadKey}
    			setSettingPlusOnes={setSettingPlusOnes}
    			settingPlusOnes={settingPlusOnes}
    			settingTypes={settingTypes}
    			settingRating={settingRating}
    			setSettingPromoters={setSettingPromoters}
    			settingPromoters={settingPromoters}
    		/>
		</>
	)
}


export default GuestiiModule;